module.exports = __webpack_public_path__ + "img/UTLOST.57350379.png";